import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import s from './PermissionBlockedPage.module.css';

interface BlockedState {
  /** Case-type guard: the display name of the blocked case type */
  caseType?: string;
  /** Case-type guard: the case reference */
  caseRef?: string;
  /** Feature guard: human-readable feature name (e.g. "Dashboard") */
  feature?: string;
}

export default function PermissionBlockedPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { caseType, caseRef, feature } = (location.state as BlockedState) ?? {};

  // Determine context — feature block takes precedence over case-type block
  const isFeatureBlock = !!feature && !caseType;
  const badgeLabel = caseType ?? feature;
  const subtitle = isFeatureBlock
    ? `You don't have permission to access the ${feature} page. Contact your administrator if you believe this is a mistake.`
    : `You don't have permission to view this case type.${
        caseRef
          ? ` Case ${caseRef} belongs to a case type that is not included in your access profile.`
          : ''
      }`;

  return (
    <div className={s.page}>
      <div className={s.iconWrap}>
        <FontAwesomeIcon icon={faLock} size="2x" />
      </div>

      <h1 className={s.title}>Access Restricted</h1>

      <p className={s.subtitle}>{subtitle}</p>

      {badgeLabel && (
        <div className={s.badge}>
          <FontAwesomeIcon icon={faLock} size="xs" />
          {badgeLabel}
        </div>
      )}

      <div className={s.actions}>
        <button className={s.btnPrimary} onClick={() => navigate('/')}>
          Go to Home
        </button>
        <button className={s.btnSecondary} onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    </div>
  );
}
